<template>
<Top-Header />
<Brand-Header />
</template>

<script setup>
import TopHeader from "./topHeader.vue";
import BrandHeader from "./brand.vue";
import { ref,onMounted } from 'vue';
import {useRoute} from 'vue-router'
let basketArray = ref()
let route = useRoute()
onMounted(() => {
  if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
  }
})
window.scrollTo(0,0);
// setBasketCounter()
// function setBasketCounter(){
//       getLocalStorage()
//       if(document.getElementById('counterBasketTemp') != null){
//         if(basketArray.value[1].length != 0 ){
//           document.getElementById('counterBasketTemp').innerHTML = basketArray.value[1].length;
//             }else{
//               document.getElementById('counterBasketTemp').innerHTML = '';
//             }
//       }
// }
// function getLocalStorage(){
// 			basketArray.value = localStorage.getItem('basket');
// 			if(basketArray.value === null){
// 				basketArray.value = [[],[],''];
// 			}else{
// 				basketArray.value = JSON.parse(basketArray.value);
// 			}
// }

</script>

<style scoped >

</style>